<template>
  <div class="banner" :style="{height:height}">
    <div class="box">
      <ul>
        <li v-for="(item, index) in list" :class="index === current ? 'active' : ''" @click="bannerClick(index, item)"
          ref="li">
          <img :src="item.imagePath" alt="">
        </li>
      </ul>

      <div class="status">
        <span v-for="(item, index) in list" :class="index === current ? 'active' : ''" @mouseenter="changeBanner(index)"
          @mouseleave="startLoop">
        </span>
      </div>
      <!-- <div class="btn">
            <span class="prev" @click="prev" @mouseenter="stopLoop" @mouseleave="startLoop"><</span>
            <span class="next" @click="next" @mouseenter="stopLoop" @mouseleave="startLoop">></span>
        </div> -->
    </div>
  </div>
</template>
<script>
  export default {
    name: 'banner',
    data() {
      return {
        current: 0, // 当前索引
        timerId: null, // 清除循环标记
        // background:require('../assets/images/banner.jpg'),
        height: ''
      }
    },
    props: [
      'list',
      'looptime',
      'width',
      'color',
    ],
    watch: {
      list(val) {
        setTimeout(() => {
          this.getHeight()
        }, 1000)
      }
    },
    methods: {
      getHeight() {
        console.log(this.$refs.li[0].offsetHeight)
        this.height = this.$refs.li[0].offsetHeight + 'px';
      },
      getArticle() {
        this.$emit('getArticle', this.article)
      },
      changeBanner(index) {
        this.$emit('change', this.current);
        this.stopLoop();
        this.current = index;
      },
      bannerClick(index, item) {
        this.$emit('click', index, item);
      },
      // 点击上一张按钮
      prev() {
        if (this.current > 0) {
          // 将对象列表对应的索引和整个对象传出去
          this.$emit('prev', this.current, this.list);
          this.current--;
        } else {
          this.$emit('prev', this.current, this.list);
          this.current = 3;
        }
      },
      // 点击下一张按钮
      next() {
        if (this.current < this.list.length - 1) {
          // this.$emit('prev', this.current, this.list);
          this.current++;
        } else {
          // this.$emit('prev', this.current, this.list);
          this.current = 0;
        }
      },
      // 鼠标移出继续循环播放
      startLoop() {
        this.int(5000);
      },
      // 鼠标移入停止循环播放
      stopLoop() {
        clearTimeout(this.timerId);
      },
      // 初始化加载
      int(time) {
        this.timerId = setInterval(() => {
          this.next();
        }, time);

      }
    },
    created() {
      this.int(5000);
    }
  }

</script>

<style lang="scss" scoped>
  .banner {
    width: 100%;
    margin: 0 auto;
    min-width: 1200px;
    height: 580px;
    overflow: hidden;

    .box {
      position: relative;
      height: 100%;

      ul {
        height: 100%;

        li {
          position: absolute;
          left: 0;
          width: 100%;
          // height: 100%;
          font-size: inherit;
          color: #fff;
          font-size: 80px;
          text-align: center;
          // background:Red;
          transition: all 1.5s;
          opacity: 0;

          img {
            width: 100%;
          }
        }

        .active {
          opacity: 1;
          transition: all 1.5s;
        }
      }

      .status {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 40px;
        text-align: Center;
        opacity: .8;

        span {
          display: inline-block;
          height: 12px;
          width: 12px;
          line-height: 12px;
          margin: 0 5px;
          background: #e1e1e1;
          border-radius: 15px;
          color: #333;
          cursor: pointer;
        }

        span.active {
          color: #fff;
          background: #c0c0c0;
        }
      }
    }

    .btn {
      position: absolute;
      top: 50%;
      width: 100%;
      transform: translateY(-50%);

      span {
        display: block;
        height: 40px;
        width: 20px;
        color: #fff;
        line-height: 40px;
        text-align: Center;
        background: rgba(0, 0, 0, .7);
        cursor: pointer;
      }

      span.prev {
        float: left;
      }

      span.next {
        float: right;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Banner.vue